module.exports = __webpack_public_path__ + "static/media/baristaespresso.ed3a6ee1.jpg";